module.exports = __webpack_public_path__ + "static/media/estiuoes.6eb0dd6b.jpg";